<template>
  <div class="work-wrap">
    <div class="mod-tit">
      <template v-if="hasShowAllPerm">
        {{ $t('data.descAll') }}
      </template>
      <template v-else>
        {{ $t('data.descTME') }}
      </template>

      <br>
      {{ $t('data.descAppend') }}
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClickTabs">
      <el-tab-pane
        v-for="(label, key) in tabsConfig"
        :name="key"
        :key="key"
      >
        <span slot="label">{{ $t(`data.tabs.${key}`) }}</span>
      </el-tab-pane>
    </el-tabs>

    <keep-alive>
      <component :is="viewComponent"></component>
    </keep-alive>
  </div>
</template>
<script>
import pageMixin from '../mixin/pageMixin'
import Perform from './perform.vue'
import Apply from './apply.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DataWork',
  components: {
    Perform,
    Apply
  },
  mixins: [pageMixin],

  data() {
    return {
      tabsConfig: {
        perform: '作品表现',
        apply: '作品应用'
      },
      activeName: ''
    }
  },

  computed: {
    viewComponent() {
      return this.activeName.replace(/^[a-z]/, word => word.toUpperCase())
    },
    ...mapGetters(['hasShowAllPerm'])
  },

  watch: {
    $route: {
      handler(newVal) {
        const { name } = this.$route.query
        this.activeName = this.tabsConfig[name] ? name : 'perform'
      },
      immediate: true
    }
  },

  methods: {
    handleClickTabs({ name }) {
      this.$router.push({
        query: {
          name
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.work-wrap {
  padding: 0 10px 10px;

  .mod-tit {
    margin: -10px 0 10px;
    color: #999;
  }

  .section-tit {
    margin: 80px 0 20px;
    font-size: 18px;
    font-weight: bold;
    color: #333;

    .sub-tit {
      margin-left: 17px;
      font-size: 16px;
      font-weight: normal;
      color: #666;
    }
  }
}

.el-tabs::v-deep {
  .el-tabs__item {
    font-size: 18px;
    &.is-active {
      font-size: 22px;
      font-weight: bold;
    }
  }
}

</style>
